import { AxiosRequestConfig } from 'axios';

const endpoint = '/api/data-model';

export default {
    reduced: () => ({ method: 'GET', url: `${endpoint}/reduced` } as AxiosRequestConfig),
    spatialConcepts: () => ({ method: 'GET', url: `${endpoint}/spatial-id-concepts` } as AxiosRequestConfig),
};
